import React from 'react';
import './App.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom'

import SiteLayout from './Components/layout/SiteLayout';
import PageNotFound from './Views/404'

import Contact from './Views/Contact';
import Home from './Views/Home';
import About from './Views/About'
import EbAccounting from './Views/EasyBooks_Accounting';
import EbAutomation from './Views/EasyBooks_ERP';
import EbIMERIS from './Views/EasyBooks_IMERIS';
import SoftwareDevelopment from './Views/SoftwareDevelopment';
import BRP from './Views/BPR';
import Clients from './Views/Clients';
import SuccessStoties from './Views/SuccessStoties';
import Team from './Views/Team';

function App() {
  
  return (
    <div id='app' className='bg-white'>
      <HashRouter>
        <SiteLayout>
          <Switch>
            <Route path='/' component={Home} exact />
            {/* Backwards-compatible aliases for old/internal links */}
            <Route path='/Software-Development' render={() => <Redirect to='/SoftwareDevelopment' />} />
            <Route path='/BPR' render={() => <Redirect to='/BRP' />} />
            <Route path='/About' component={About} />
            <Route path='/Contact' component={Contact} />
            <Route path='/EasyBooks_Accounting' component={EbAccounting} />
            <Route path='/EasyBooks_ERP' component={EbAutomation} />
            <Route path='/EasyBooks_IMERIS' component={EbIMERIS} />
            <Route path='/SoftwareDevelopment' component={SoftwareDevelopment} />
            <Route path='/BRP' component={BRP} />
            <Route path='/Clients' component={Clients} />
            <Route path='/SuccessStories' component={SuccessStoties} />
            <Route path='/Team' component={Team} />
            <Route path='*' component={PageNotFound} />
          </Switch>
        </SiteLayout>

      </HashRouter>
    </div>

  );
}

export default App;
